export const GET_DASHBOARD_DATA_REQUEST = 'GET_DASHBOARD_DATA_REQUEST';

export const GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS';

export const GET_DASHBOARD_DATA_FAILURE = 'GET_DASHBOARD_DATA_FAILURE';

export const UNLOAD_DASHBOARD = 'UNLOAD_DASHBOARD';

export const GET_UPTIME_REQUEST = 'GET_UPTIME_REQUEST';

export const GET_UPTIME_SUCCESS = 'GET_UPTIME_SUCCESS';

export const GET_UPTIME_FAILURE = 'GET_UPTIME_FAILURE';

export const GET_SERVICES_STATUS_REQUEST = 'GET_SERVICES_STATUS_REQUEST';

export const GET_SERVICES_STATUS_SUCCESS = 'GET_SERVICES_STATUS_SUCCESS';

export const GET_SERVICES_STATUS_FAILURE = 'GET_SERVICES_STATUS_FAILURE';

export const GET_FIREWALL_POLICIES_STATUS_REQUEST = 'GET_FIREWALL_POLICIES_STATUS_REQUEST';

export const GET_FIREWALL_POLICIES_STATUS_SUCCESS = 'GET_FIREWALL_POLICIES_STATUS_SUCCESS';

export const GET_FIREWALL_POLICIES_STATUS_FAILURE = 'GET_FIREWALL_POLICIES_STATUS_FAILURE';

export const GET_FIREWALL_SERVICES_STATUS_REQUEST = 'GET_FIREWALL_SERVICES_STATUS_REQUEST';

export const GET_FIREWALL_SERVICES_STATUS_SUCCESS = 'GET_FIREWALL_SERVICES_STATUS_SUCCESS';

export const GET_FIREWALL_SERVICES_STATUS_FAILURE = 'GET_FIREWALL_SERVICES_STATUS_FAILURE';

export const GET_WEB_SECURITY_STATUS_REQUEST = 'GET_WEB_SECURITY_STATUS_REQUEST';

export const GET_WEB_SECURITY_STATUS_SUCCESS = 'GET_WEB_SECURITY_STATUS_SUCCESS';

export const GET_WEB_SECURITY_STATUS_FAILURE = 'GET_WEB_SECURITY_STATUS_FAILURE';

export const GET_PARTITIONS_STATUS_REQUEST = 'GET_PARTITIONS_STATUS_REQUEST';

export const GET_PARTITIONS_STATUS_SUCCESS = 'GET_PARTITIONS_STATUS_SUCCESS';

export const GET_PARTITIONS_STATUS_FAILURE = 'GET_PARTITIONS_STATUS_FAILURE';

export const GET_STORAGE_USAGE_REQUEST = 'GET_STORAGE_USAGE_REQUEST';

export const GET_STORAGE_USAGE_SUCCESS = 'GET_STORAGE_USAGE_SUCCESS';

export const GET_STORAGE_USAGE_FAILURE = 'GET_STORAGE_USAGE_FAILURE';

export const GET_ACTIVE_CALLS_REQUEST = 'GET_ACTIVE_CALLS_REQUEST';

export const GET_ACTIVE_CALLS_SUCCESS = 'GET_ACTIVE_CALLS_SUCCESS';

export const GET_ACTIVE_CALLS_FAILURE = 'GET_ACTIVE_CALLS_FAILURE';

export const GET_UPDATES_REQUEST = 'GET_UPDATES_REQUEST';

export const GET_UPDATES_SUCCESS = 'GET_UPDATES_SUCCESS';

export const GET_UPDATES_FAILURE = 'GET_UPDATES_FAILURE';

export const GET_DEVICES_UPDATES_REQUEST = 'GET_DEVICES_UPDATES_REQUEST';

export const GET_DEVICES_UPDATES_SUCCESS = 'GET_DEVICES_UPDATES_SUCCESS';

export const GET_DEVICES_UPDATES_FAILURE = 'GET_DEVICES_UPDATES_FAILURE';

export const GET_WEAK_PASSWORDS_REQUEST = 'GET_WEAK_PASSWORDS_REQUEST';

export const GET_WEAK_PASSWORDS_SUCCESS = 'GET_WEAK_PASSWORDS_SUCCESS';

export const GET_WEAK_PASSWORDS_FAILURE = 'GET_WEAK_PASSWORDS_FAILURE';

export const GET_VPN_STATUS_REQUEST = 'GET_VPN_STATUS_REQUEST';

export const GET_VPN_STATUS_SUCCESS = 'GET_VPN_STATUS_SUCCESS';

export const GET_VPN_STATUS_FAILURE = 'GET_VPN_STATUS_FAILURE';

export const GET_CALLS_SUMMARY_REQUEST = 'GET_CALLS_SUMMARY_REQUEST';

export const GET_CALLS_SUMMARY_SUCCESS = 'GET_CALLS_SUMMARY_SUCCESS';

export const GET_CALLS_SUMMARY_FAILURE = 'GET_CALLS_SUMMARY_FAILURE';

export const GET_TOTAL_CALLS_REQUEST = 'GET_TOTAL_CALLS_REQUEST';

export const GET_TOTAL_CALLS_SUCCESS = 'GET_TOTAL_CALLS_SUCCESS';

export const GET_TOTAL_CALLS_FAILURE = 'GET_TOTAL_CALLS_FAILURE';
